/*
 *
 *  remotes
 *
 */

import api from '../../helpers/Api'
//import constantName from './key'
import { isEmpty } from "lodash"
  
export function loadRecordsMetaData(metaData, method) {
  if (method === "post") {
    return api
      .post(`/get_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

  export async function passwordApi(searchValue){
    if(!isEmpty(searchValue)){
    return await api
        .post(`/get_print_vendor`,searchValue)
        .then((response) => response.data)
        .catch((error) => Promise.reject(error))}
    
  }

  export function changePasswordApi(changeData){
   if(changeData){
    return api
        .post(`/vendor_reset_password`,changeData)
        .then((response) => response.data)
        .catch((error) => Promise.reject(error))}
    
  }


const remotes = {
    passwordApi,
    changePasswordApi,
    loadRecordsMetaData,
}

export default remotes